import { Component, Input } from '@angular/core';
import { Incasso } from '../../../models/incasso';

@Component({
    selector: '[incasso_entity_view]',
  templateUrl: 'incasso-entity-view.component.html',
})

export class IncassoEntityViewComponent {
  @Input()
  element: Incasso;
}
